<template>
  <v-footer height="211" class="mt-n16 primary darken-1">
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" align="start" align-self="start">
        <h2 style="font-size: 1.5rem">Infohidro</h2>
        <p style="text-decoration:none; color: white; font-size: 1rem">
          Todos os direitos reservados © simepar.br
        </p>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" align="end" align-self="end">
        <v-btn v-for="(item, index) in icons" :key="index" :class="$vuetify.breakpoint.name === 'xs' ? 'mx-1' : 'mx-3'" dark icon @click="openLink(item)">
          <v-img
            v-if="item.id === 0"
            :src="item.img"
            class="mr-16 ml-n16"
            contain
            alt="logo simepar"
            height="32"
            width="150"
          ></v-img>
          <v-icon v-else size="32">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </v-col>
<!--      <v-col cols="12" v-if="$vuetify.breakpoint.name === 'xs'">
        <v-btn dark icon @click="openLink('http://www.simepar.br/')">
          <v-img
            :src="require('@/assets/logo_simepar.png')"
            contain
            alt="simepar"
            height="32"
            width="150"
          ></v-img>
        </v-btn>
      </v-col>-->
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "FooterWeather",
  data(){
    return{
      icons: [
        { img: require('@/assets/simepar-logo-branco.svg') , link: "http://www.simepar.br/", id: 0 },
        { icon: "icon-infohidro-instagram", link: "https://www.instagram.com/simeparpr/", id: 4},
        { icon: "icon-infohidro-twitter", link: "https://twitter.com/simeparpr", id: 2},
        { icon: "icon-infohidro-linkedin", link: "https://br.linkedin.com/company/sistema-met-parana-simepar", id: 3},
        { icon: "icon-infohidro-facebook", link: "https://www.facebook.com/simeparparana/", id: 1 },
      ],
    }
  },
  methods:{
    openLink(item){
      window.open(item.link, '_blank');
    },
  }
}
</script>

<style scoped>
</style>
